import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import classNames from 'classnames';
import { Experiments, PurchaseMode } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { Box } from '@wix/design-system';
import { LastDaySaleBannerContent } from './LastDaySaleBannerContent';
import s from './SaleBanner.scss';
import { SaleBannerContent } from './SaleBannerContent';

interface SaleBannerProps extends InjectedExperimentsProps {
  rootStore: RootStore;
}

const SaleBannerComp: React.FunctionComponent<SaleBannerProps> = ({
  rootStore,
  experiments,
}) => {
  const { purchaseMode } = rootStore.appStore.appContext;
  const { theme } = usePageModeContext();

  const isPersonalSaleCountdownEnabled = experiments.enabled(Experiments.PersonalSaleCountdown)
  const shouldShowLastDaySaleBanner = purchaseMode === PurchaseMode.LAST_DAY_SALE || (isPersonalSaleCountdownEnabled && purchaseMode === PurchaseMode.PERSONAL_SALE_AGE_3);

  return (
    <Box className={classNames(s.saleStrip, theme)} dataHook='sale-banner'>
      <Box
        padding='13px 36px'
        verticalAlign='middle'
        align='center'
        width='100%'
        textAlign='center'
      >
        {shouldShowLastDaySaleBanner ? (
          <LastDaySaleBannerContent />
        ) : (
          <SaleBannerContent />
        )}
      </Box>
    </Box>
  );
};

export const SaleBanner = withInjectedRootStore(
  withExperiments(SaleBannerComp),
);
